import React from 'react';
import SchoolHeader from '@/components/SchoolHeader';
import CtaButton from '@/components/CtaButton';
import { safeHttpsUrl } from '@/services/links';

/**
 * ACH microdeposit wait state. The mandate is already accepted and stored as
 * a PENDING enrollment — once Stripe verifies the bank (1–2 business days),
 * the setup_intent.succeeded webhook turns Auto-Pay on automatically and the
 * confirmation email goes out. `verification` (next_action.
 * verify_with_microdeposits) is only present right after the confirm; the
 * returning-visitor variant renders the generic copy.
 */
const PendingBankVerificationScreen = ({ school, studentName, verification }) => {
	// A link we cannot vouch for is no link at all: the returning-visitor
	// variant has no `verification` at all, and Stripe does not always publish
	// a hosted page even when it does.
	const verificationUrl = safeHttpsUrl(verification?.hosted_verification_url);

	return (
		<div className="flex flex-col gap-[18px]">
			<SchoolHeader name={school?.name} logo={school?.logo} />

			<h1 className="text-[24px] font-extrabold text-pay-ink">We’re verifying your bank account</h1>

			<p className="text-[14px] leading-[21px] text-pay-muted">
				Your bank needs a quick verification before Auto-Pay
				{studentName ? ` for ${studentName}` : ''} can start. Stripe{' '}
				{verification?.microdeposit_type === 'descriptor_code'
					? 'sent a small deposit with a 6-digit code (SMXXXX)'
					: 'sent two small deposits'}{' '}
				to your account — this usually takes 1–2 business days to appear.
			</p>

			<p className="text-[14px] leading-[21px] text-pay-muted">
				Watch for an email from Stripe with a verification link. Once you confirm the
				{verification?.microdeposit_type === 'descriptor_code' ? ' code' : ' amounts'}, Auto-Pay turns on automatically
				— no need to come back here — and we’ll email your confirmation.
			</p>

			{verificationUrl ? (
				<CtaButton onClick={() => window.open(verificationUrl, '_blank', 'noopener')}>Verify deposits</CtaButton>
			) : null}
		</div>
	);
};

export default PendingBankVerificationScreen;
